import Vue from "vue";
import Component from "vue-class-component";
import { Prop, Watch } from "vue-property-decorator";
import Localizer from "@Scripts/Common/Localizer";

@Component({ name: "CatalogueSearch" })
export default class CatalogueSearch extends Vue {
    public localizer: any = Localizer; 
    public vehicleTypeComponent: string = null; 
    public isShowSearch: boolean = false; 
    public vehicleType: string = null; 
    public searchMode: string = null; 
    public isTooltipVisible: boolean = false; 
    public timer: any = null; 

    public selectedProductTypes: string = null;
    public aftermarketList: any[] = [];
    public upgradeList: any[] = [];
    public searchVehicleTypes: any[] = [];
    public isSelectingAllAftermarket: boolean = true;
    public isSelectingAllUpgrade: boolean = true;
    public isUpgrade: boolean = false;
    public vehicleFilter: any = { productSize: "Disc", productTypes: ["All"] };
    public search: any = { title: null };

    @Prop() readonly region: string; 
    @Prop() readonly culture: string; 
    @Prop() readonly country: string; 
    @Prop() readonly filter: any; 
    @Prop() readonly plateCountries: any; 
    @Prop() readonly searchCarProductTypes: any; 
    @Prop() readonly searchBikeProductTypes: any; 
    @Prop() readonly isHome: boolean; 
    @Prop() readonly isUserAuthenticated: boolean; 

    @Watch("isCatalogueSearchHide") onIsCatalogueSearchHideChange(newValue: string, oldValue: string) {
        this.isShowSearch = true;
    }

    @Watch("catalogueSearchMode") onCatalogueSearchModeChange(newValue: string, oldValue: string) {
        this.setSearchMode(newValue);
        this.isTooltipVisible = true;

        clearTimeout(this.timer);

        this.timer = setTimeout(x => {
            this.isTooltipVisible = false;
        }, 3500);
    }

    get isCatalogueSearchHide() {
        return this.$store.getters["catalogueSearchStore/isCatalogueSearchHide"];
    }

    get catalogueSearchMode() {
        return this.$store.getters["catalogueSearchStore/catalogueSearchMode"];
    }

    get routes() {
        return (<any>window).App.routes;
    }

    public created() {
        this.vehicleType = <string>this.$route.query.vehicleType != null ? <string>this.$route.query.vehicleType : window.localStorage.getItem("vehicleType");
        if (this.filter.vehicleType) {
            this.vehicleType = this.filter.vehicleType
        }

        this.getSearchType(this.vehicleType);

        if (this.filter.productTypes != null && this.filter.productTypes.length >= 1) {
            this.vehicleFilter.productTypes = this.filter.productTypes;
        }

        if (this.filter.productType) {
            this.vehicleFilter.productSize = this.filter.productType;
        }
    }

    public getSearchType(vehicleType: string) {
        window.localStorage.setItem("vehicleType", vehicleType);
        this.vehicleType = vehicleType;

        this.search = { title: null };

        this.setSearchMode("Type"); 
        switch (this.region) { 
            case 'america': 
                switch (vehicleType) { 
                    case "Bike": return this.vehicleTypeComponent = "app-globalcataloguebikesearch"; 
                    default: 
                        this.vehicleType = "Car"; 
                        return this.vehicleTypeComponent = "app-globalcataloguecarsearch"; 
                } 
            default: 
                switch (vehicleType) { 
                    case "Truck": return this.vehicleTypeComponent = "app-globalcataloguetrucksearch"; 
                    case "Bike": return this.vehicleTypeComponent = "app-globalcataloguebikesearch"; 
                    default: 
                        this.vehicleType = "Car"; 
                        return this.vehicleTypeComponent = "app-globalcataloguecarsearch"; 
                } 
        } 
    }

    public async setShowSearch() {
        this.isShowSearch = !this.isShowSearch;
    }

    public setSearchMode(mode: string) {
        this.searchMode = mode;
        this.vehicleFilter.productTypes = ["All"];
    }

    public changeProductSize(productSize: string) {
        this.vehicleFilter.productSize = productSize;
    }

    public async setFilterData(data: any) {
        this.searchVehicleTypes = [];
        if (data.vehicleType === "Bike") {
            this.searchVehicleTypes = this.searchBikeProductTypes;
        } else {
            this.searchVehicleTypes = this.searchCarProductTypes;
        }

        this.vehicleFilter.productTypes = data.productTypes ? data.productTypes : ["All"];
        this.isSelectingAllAftermarket = data.isSelectingAllAftermarket;
        this.isSelectingAllUpgrade = data.isSelectingAllUpgrade;
        this.isUpgrade = data.isUpgrade;
        this.selectedProductTypes = data.selectedProductTypes;
    }

    public setSearchBar(vehicle: any) {
        this.search.title = vehicle.title;
        this.search.subTitle = vehicle.subTitle;
    }

    public setProductTypes(e: any) {
        (<any>this.$refs.childComponentRef).setProductTypes(e);
    }

    public submitTypeForm() {
        (<any>this.$refs.childComponentRef).submitTypeForm();
    }
};
